import { find, findAllBy } from "./base";

const PROFESSIONALS = ["professionals", "professionals"];

export const professional = (state) => (id) => find(state)(PROFESSIONALS, id);
export const professionals = (state) => (params) =>
  findAllBy(state)(PROFESSIONALS, params);

export const pro = professional;
